import Vue from 'vue'
import VueI18n from 'vue-i18n'
import qs from 'querystring'
import axios from 'axios'

const search = qs.parse(window.location.search.slice(1))

Vue.use(VueI18n)

const DEFAULT_LANG = 'zh'
const LOCALE_KEY = 'localeLanguage'

const LANG_ZH = {
  search_placeholder: '输入您想搜索的内容',
  feedback: '意见反馈',
  help_center: '帮助中心',
  cms: '多客汇',
  help_document: '帮助文档',
  soft_spread: '软文推广',
  client: '客户',
  good: '好',
  midnight: '午夜好',
  morning: '早上好',
  forenoon: '上午好',
  noon: '中午好',
  afternoon: '下午好',
  night: '晚上好',
  welcome_speech: '欢迎来到帮助中心，很高兴为您服务',
  online_answer: '在线解答',
  feedback_desc: '提出您的反馈意见',
  online_answer_desc: '在线解答您的问题',
  hotline: '客服热线',
  service_time: '服务时间',
  hotpot_issues: '热点问题',
  all: '全部',
  global_search: '全局搜',
  empty_search: '未找到搜索项，请换个试试',
  question_source: '问题来源',
  i_ios: '苹果设备',
  i_andriod: '安卓设备',
  i_weshop: '微店铺',
  i_print: '打印机',
  search: '搜索',
  detail: '详情',
  published: '发布于',
  read: '阅读',
  send: '发送',
  feedback_placeholder: '意见反馈字数不得小于10字，以便我们能提供更好的帮助',
  contact_method: '联系方式',
  contact_placeholder: '输入11位手机号码',
  contact_placeholder1: '请输入号码',
  feedback_validate1: '字数不得小于10字',
  feedback_validate2: '字数不得多于200字',
  feedback_validate3: '请填写正确的手机号',
  success: '成功',
  fail: '失败',
  submit_error: '提交出错了，请联系客服人员',
  submit: '提交',
  novice_tutorial: '新手教程',
}

const defaultLocals = {
  zh: LANG_ZH,
  chs: LANG_ZH,
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG, // 设置语言环境
  messages: defaultLocals, // 设置语言信息
})
export const setup = (
  lang = search.lang || DEFAULT_LANG,
  locals = defaultLocals
) => {
  if (!lang) {
    lang = localStorage[LOCALE_KEY]

    if (!locals[lang]) {
      lang = DEFAULT_LANG
    }
  }

  // eslint-disable-next-line no-use-before-define
  loadLanguageAsync(lang)
  localStorage[LOCALE_KEY] = lang

  Object.keys(locals).forEach((l) => {
    document.body.classList.remove(`lang-${l}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)

  Vue.config.lang = lang
  i18n.locale = lang
}

export function loadLanguageAsync(lang) {
  if (lang !== DEFAULT_LANG && !defaultLocals[lang]) {
    const query = {
      lang,
      utime: 0,
      project: 4,
      type: 'test',
      keys: JSON.stringify(Object.keys(defaultLocals.zh)),
    }
    return axios
      .get(
        `https://translate2.dokkr.net/index.php/api/get_file?${qs.stringify(
          query
        )}`
      )
      .then((res) => {
        if (res.status === 200 && res.data.info) {
          for (const [myKeys, myValues] of Object.entries(res.data.info)) {
            if (myValues === '') {
              delete res.data.info[myKeys]
            }
          }
        }
        i18n.setLocaleMessage(lang, res.data.info)
      })
      .catch(() => {
        // 请求失败设置默认的语言
        return setup(DEFAULT_LANG)
      })
  }
  return Promise.resolve(lang)
}

window.i18n = i18n
setup()

export default i18n



// WEBPACK FOOTER //
// ./src/utils/i18n.js